import { AgGrid, Grid } from "@jsq/ds/core";
import { useAgGridDefaults } from "~/pages/UserAndRoles/utils/gridConfig";
import { UserTableContext, useSelectRows } from "./hooks/useSelectRows";
import { useUserTableConfiguration } from "./hooks/useUserTableConfiguration";

export type UserRow = {
  id: number;
  name: string;
  email: string;
  activeWorkspaces: number;
  lastAccessDate: string;
  bulkArenaAccess: "Yes" | "No";
};

export type UsersTableProps = {
  onGridReady: (event: AgGrid.GridReadyEvent<UserRow>) => void;
  userRows: UserRow[];
  onRowClicked: (event: AgGrid.RowClickedEvent<UserRow>) => void;
  gridApi: AgGrid.GridApi | null;
  onFilterChanged: (event: AgGrid.FilterChangedEvent) => void;
};

export const UsersTable = ({
  onGridReady,
  userRows,
  gridApi,
  onRowClicked,
  onFilterChanged,
}: UsersTableProps) => {
  const { onSelectionChanged, sideBar, selectedRows } = useSelectRows({ gridApi });
  const { columnDefs } = useUserTableConfiguration();

  const { gridOptions } = useAgGridDefaults({
    overrides: {
      paginationPageSize: 50,
      overlayNoRowsTemplate: "No users found",
      suppressRowClickSelection: true,
      suppressCellFocus: true,
      statusBar: {
        statusPanels: [{ statusPanel: "agTotalRowCountComponent" }],
      },
      rowSelection: "multiple",
      sideBar,
    },
  });

  return (
    <UserTableContext.Provider value={{ users: selectedRows }}>
      <Grid
        onGridReady={onGridReady}
        rowData={userRows}
        columnDefs={columnDefs}
        gridOptions={gridOptions}
        onRowClicked={onRowClicked}
        onSelectionChanged={onSelectionChanged}
        onFilterChanged={onFilterChanged}
      />
    </UserTableContext.Provider>
  );
};
